export default ($api) => ({
  luaChonNhaDauTu: (data) => {
    return $api.get(`bai-viets`, { params: data })
  },
  chiTietLuaChonNhaDauTu: (id) => {
    return $api.get(`bai-viets/${id}`)
  }
})
